import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { EXTERNAL_POD_COVER_GUIDE } from "@/settings/constant";
import CoverSample from "@/static/assets/pod-covers/cover-sample.png";
import CoverImage1 from "@/static/assets/pod-covers/pod-cover-1.png";
import CoverImage2 from "@/static/assets/pod-covers/pod-cover-2.png";
import CoverImage3 from "@/static/assets/pod-covers/pod-cover-3.png";
import CoverImage4 from "@/static/assets/pod-covers/pod-cover-4.png";
import CoverImage5 from "@/static/assets/pod-covers/pod-cover-5.png";
import CoverImage6 from "@/static/assets/pod-covers/pod-cover-6.png";
import { Button, DialogTitle } from "@bookips/sds";
import Image from "next/image";
import { Controller, useFormContext } from "react-hook-form";
import { useDialogStore } from "src/store/useDialogStore";
import useSnackbar from "src/store/useSnackbar";
import { Image as ImageIcon } from "../icon/IconList";
import FileUploadBox from "./FileUploadBox";
import RadioBox from "./RadioBox";
import SectionContainer from "./SectionContainer";
import SectionLabel from "./SectionLabel";
import TextField from "./TextField";
const coverImages = [
    CoverImage1,
    CoverImage2,
    CoverImage3,
    CoverImage4,
    CoverImage5,
    CoverImage6
];
const CoverSettings = ()=>{
    var _errors_title, _errors_name;
    const { addSnackbar  } = useSnackbar();
    const { open , close  } = useDialogStore();
    const { control , setValue , register , watch , formState: { errors  }  } = useFormContext();
    const coverCustomImage = watch("coverCustomImage");
    const handleOpenCoverSample = ()=>{
        open({
            id: "cover-sample",
            type: "custom",
            props: {
                title: /*#__PURE__*/ _jsx(DialogTitle, {
                    title: "표지 샘플보기",
                    description: "교재명, 학원명, 학원 전화번호는 표지 앞,뒷면에 표시해드려요."
                }),
                children: /*#__PURE__*/ _jsx("div", {
                    className: "mx-auto sm:px-0 px-7 max-w-[464px]",
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: CoverSample,
                        alt: "표지 샘플이미지"
                    })
                }),
                footer: /*#__PURE__*/ _jsx("div", {
                    className: "flex justify-end p-7 pt-0",
                    children: /*#__PURE__*/ _jsx(Button, {
                        size: "lg",
                        className: "w-full sm:w-fit",
                        onClick: ()=>close("cover-sample"),
                        children: "확인"
                    })
                }),
                size: "sm",
                classes: {
                    contentWrapper: "sm:w-[520px]"
                },
                contentProps: {
                    onInteractOutside: ()=>{
                        close("cover-sample");
                    }
                }
            }
        });
    };
    const handleOpenCoverGuide = ()=>{
        mixpanelEvent("Guide Button Clicked", {
            "Guide Categories": "POD 커스텀 디자인 안내"
        });
        window.open(EXTERNAL_POD_COVER_GUIDE, "_blank");
    };
    const handleCoverImageChange = (e)=>{
        const value = e.target.value;
        if (coverCustomImage) {
            e.preventDefault();
            open({
                id: "delete-file",
                type: "confirm",
                props: {
                    title: "기본 디자인으로 변경할까요?",
                    description: "기본 디자인으로 변경하면 등록된 이미지 파일은 삭제돼요.",
                    severity: "error",
                    confirmText: "변경하기",
                    onConfirm: ()=>{
                        setValue("coverCustomImage", undefined);
                        setValue("coverImage", value);
                        addSnackbar({
                            message: "파일을 삭제했어요.",
                            variant: "error"
                        });
                    },
                    cancelText: "취소",
                    onCancel: ()=>{
                        setValue("coverImage", undefined);
                    }
                }
            });
        } else {
            setValue("coverImage", value);
        }
    };
    return /*#__PURE__*/ _jsxs(SectionContainer, {
        title: "표지 구성",
        leftAction: /*#__PURE__*/ _jsx(Button, {
            size: "sm",
            variant: "stroke",
            color: "secondary",
            onClick: handleOpenCoverSample,
            children: "표지 샘플보기"
        }),
        children: [
            /*#__PURE__*/ _jsx(SectionLabel, {
                title: "기본 디자인",
                children: /*#__PURE__*/ _jsx("ul", {
                    className: "grid grid-cols-2 sm:grid-cols-3 gap-3",
                    children: coverImages.map((cover, index)=>/*#__PURE__*/ _jsx("li", {
                            children: /*#__PURE__*/ _jsx(RadioBox, {
                                label: /*#__PURE__*/ _jsx(Image, {
                                    className: "w-[112px]",
                                    src: cover,
                                    alt: "표지 이미지 ".concat(index + 1)
                                }),
                                value: index + 1,
                                ...register("coverImage"),
                                onChange: handleCoverImageChange
                            })
                        }, cover.src))
                })
            }),
            /*#__PURE__*/ _jsxs(SectionLabel, {
                title: "커스텀 디자인",
                children: [
                    /*#__PURE__*/ _jsx(Controller, {
                        control: control,
                        name: "coverCustomImage",
                        render: (param)=>/*#__PURE__*/ {
                            let { field  } = param;
                            return _jsx(FileUploadBox, {
                                icon: ImageIcon,
                                title: "커스텀 디자인",
                                description: "30MB 이하로 1개만 등록 가능해요.\n(png, jpeg, jpg, pdf만 가능)",
                                fileType: "image",
                                file: field.value,
                                onFileSelect: (file)=>{
                                    field.onChange(file);
                                    setValue("coverImage", undefined);
                                },
                                onFileDelete: ()=>{
                                    setValue("coverImage", "1");
                                }
                            });
                        }
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        size: "lg",
                        variant: "stroke",
                        color: "secondary",
                        className: "w-full",
                        onClick: handleOpenCoverGuide,
                        children: "커스텀 디자인 안내"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(TextField, {
                label: "교재명",
                placeholder: "예: 수능특강 라이트 핵심문제집",
                helperText: ((_errors_title = errors.title) === null || _errors_title === void 0 ? void 0 : _errors_title.message) || "30자 이하(공백 포함)로 작성해주세요.",
                error: !!errors.title,
                maxLength: 30,
                ...register("title", {
                    required: "필수 입력 사항이에요."
                })
            }),
            /*#__PURE__*/ _jsx(TextField, {
                label: "학원명",
                placeholder: "예: 쏠북 영어학원",
                helperText: ((_errors_name = errors.name) === null || _errors_name === void 0 ? void 0 : _errors_name.message) || "20자 이하(공백 포함)로 작성해주세요.",
                error: !!errors.name,
                maxLength: 20,
                ...register("name", {
                    required: "필수 입력 사항이에요."
                })
            }),
            /*#__PURE__*/ _jsx(TextField, {
                label: "학원 전화번호 (선택)",
                placeholder: "예: 01012345678",
                maxLength: 15,
                ...register("tel"),
                onInput: (e)=>{
                    e.currentTarget.value = e.currentTarget.value.replace(/\D/g, "") // 숫자만 남기기
                    ;
                }
            })
        ]
    });
};
export default CoverSettings;
